import LoginLayout from './LoginLayout';
import { useState, useEffect } from 'react';
import lodash from 'lodash';

import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { getChallengeQuestion, setResetPasswordAnswerError, setResetPasswordValidationError } from '../../actions/login';
import { Link } from 'react-router';
import styles from './Login.scss';
import PasswordValidation from './PasswordValidation';
import { checkValidPassword } from './CheckValidPassword';

const ResetPassword = (props) => {
    const { setResetPasswordAnswerError, setResetPasswordValidationError, onChallengeQuestionAnswer, onResetPassword, me } = props;

    const [answer, setAnswer] = useState('');
    const [password, setPassword] = useState('');
    const [passwordType, setPasswordType] = useState(true);
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [validPassword, setValidPassword] = useState(false);
    const [backToSignIn, showBackToSignIn] = useState(false);
    const [invalidUrlError, setInvalidURlError] = useState('');
    const [challengeQuestion, setChallengeQuestion] = useState();
    const [resetPasswordParams, setResetPasswordParams] = useState();

    useEffect(() => {
        const fetchData = async () => {
            const fullUrl = window.location.href;
            const url = new URL(fullUrl);
            const params = new URLSearchParams(url.search);

            const resetPasswordUrl = params.get('resetPasswordUrl');
            const email = params.get('email');
            const api = params.get('api');

            if (resetPasswordUrl) {
                const encodedEmail = email ? encodeURIComponent(email) : '';

                let formattedUrl = `${resetPasswordUrl}`;

                if (encodedEmail) {
                    formattedUrl += `?email=${encodedEmail}`;
                }

                if (api) {
                    formattedUrl += `&api=${api}`;
                }


                try {
                    const challengeQuestion = await getChallengeQuestion(formattedUrl);
                    if (challengeQuestion.error) {
                        setInvalidURlError(challengeQuestion.error);
                    }
                    else {
                        setChallengeQuestion(challengeQuestion);
                    }
                } catch (error) {
                    setInvalidURlError(error);
                }
            } else {
                setInvalidURlError('This password reset request is no longer valid. Please request another password reset.');
            }
        };

        fetchData();
    }, []);




    const onSubmitClick = async (e) => {
        e.preventDefault();

        if (!showResetPassword && answer === '') {
            setResetPasswordAnswerError('Please answer the question.');
            return;
        }
        else {
            const response = await onChallengeQuestionAnswer(e, answer, challengeQuestion);
            if (response.error) {
                setResetPasswordAnswerError(response.error);
                return;
            }
            else {
                setResetPasswordParams(response);
            }
        }
        if (!showResetPassword) {
            setShowResetPassword(true);
            return;
        }
        if (password === '') {
            setResetPasswordValidationError('Please enter your new password.');
            return;
        }
        if (!validPassword || !checkValidPassword(password)) {
            setResetPasswordValidationError('Your password does not meet our requirements.');
            return;
        }
        if (validPassword) {
            const response = await onResetPassword(e, password, resetPasswordParams);
            if (response.message) {
                setValidPassword(false);
                showBackToSignIn(true);
            }
            else {
                if (response.error && response.error.startsWith('Validation error: ')) {
                    response.error = response.error.replace('Validation error: ', '');
                }
                setValidPassword(false);
                setResetPasswordValidationError(response.error || 'Something went wrong, please try again !');
                return;
            }
        }

    };


    const togglePasswordVisibility = () => {
        setPasswordType(!passwordType);
    };

    return (
        <LoginLayout>
            {backToSignIn ? <div className={styles.complionTitle}>
                Password Changed!
            </div> : <div className={styles.complionTitle}>
                Reset Password
                {!showResetPassword && !backToSignIn && <div className={styles.caption}>
                    Please answer the security question to continue.
                </div>}
                {showResetPassword && !backToSignIn && <div className={styles.caption}>
                    Please set your new password.
                </div>}
            </div>}



            <form autoComplete="off" className={styles.form} onSubmit={onSubmitClick}>
                {invalidUrlError !== '' && <div className={styles.complionSubTitle} style={{ color: 'red' }}>{invalidUrlError}</div>}
                {!showResetPassword && !backToSignIn && invalidUrlError === '' &&

                    (<div className={styles.formGroup}>
                        <div className={styles.labelGroup}>
                            <label htmlFor="answer" className={styles.inputLabelv4}>
                                {challengeQuestion ? challengeQuestion.question : ''}
                            </label>
                        </div>

                        <input
                            id="answer"
                            className={`${styles.inputv4} ${props.resetPasswordAnswerError && styles.inputErrorv4}`}
                            type="answer"
                            name="answer"
                            value={answer}
                            onChange={(e) => setAnswer(e.target.value)}
                            autoFocus
                        />

                        {props.resetPasswordAnswerError && <pre className={styles.errorv4}>{props.resetPasswordAnswerError}</pre>}

                    </div>
                    )}

                {showResetPassword && !backToSignIn && (
                    <div className={styles.formGroup}>
                        <div className={styles.labelGroup}>
                            <label htmlFor="password" className={styles.inputLabelv4}>
                                New password
                            </label>
                        </div>
                        <div className={`${styles.passowordInput} ${props.resetPasswordValidationError && styles.passowordInputError}`}>
                            <input
                                id="password"
                                className={`${props.resetPasswordValidationError && styles.inputErrorv4}`}
                                type={passwordType ? 'password' : 'text'}
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={passwordType ? faEye : faEyeSlash}
                                className={styles.passwordIcon}
                                onClick={togglePasswordVisibility}
                            />
                        </div>
                        {props.resetPasswordValidationError && <span className={styles.errorv4}>{props.resetPasswordValidationError}</span>}
                        <PasswordValidation password={password} setValidPassword={setValidPassword} />
                    </div>

                )}

                {backToSignIn && <div className={styles.backToSignIn} >
                    <Link to={!lodash.isEmpty(me) ? '/registration' : '/'} className={styles.backToSignIn} >
                        <FontAwesomeIcon
                            icon={faArrowLeft}
                            style={{ marginRight: '4px' }}
                        />
                        Back to sign in
                    </Link>
                </div>}


                {!backToSignIn && invalidUrlError === '' && <div className={styles.formGroup}>
                    <button type="submit" className={styles.actionButtonv4}>
                        {showResetPassword ? 'Change Password' : 'Continue'}
                    </button>
                </div>
                }
            </form>
        </LoginLayout>
    );
};
const mapStateToProps = (state) => ({
    resetPasswordAnswerError: lodash.get(state, 'resetPasswordAnswerError', false),
    resetPasswordValidationError: lodash.get(state, 'resetPasswordValidationError', false),
    me : lodash.get(state, 'me', {})
});

export default connect(mapStateToProps, { setResetPasswordAnswerError, setResetPasswordValidationError })(ResetPassword);